import React from 'react';
import { useNavigate } from 'react-router-dom';
import './About.css';

function About() {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <div className="page-content">
        <button className="back-button" onClick={() => navigate('/')}>
          ← Back to Home
        </button>

        <h1>About PhenoGuessr</h1>

        <section>
          <h2>What is PhenoGuessr?</h2>
          <p>
            PhenoGuessr is an educational geography game that challenges players to identify the
            geographic origins of human phenotypes from around the world. By observing facial features
            and physical characteristics, you'll learn about human diversity and global population
            distributions across different continents and regions.
          </p>
        </section>

        <section>
          <h2>How It Works</h2>
          <p>
            Each game consists of 10 rounds where you're presented with images showing typical
            phenotypic features from a specific geographic region. Your task is to guess the location
            on an interactive world map. The closer your guess to the actual region, the higher your
            score!
          </p>
          <ul>
            <li><strong>Perfect guess (0-50 km):</strong> Maximum 5000 points</li>
            <li><strong>Close guess (50-500 km):</strong> 2000-4500 points</li>
            <li><strong>Moderate guess (500-1000 km):</strong> 500-2000 points</li>
            <li><strong>Far guess (1000-2000 km):</strong> 100-500 points</li>
            <li><strong>Very far (2000+ km):</strong> 0 points</li>
          </ul>
        </section>

        <section>
          <h2>Educational Purpose</h2>
          <p>
            PhenoGuessr is designed to be an educational tool that helps players:
          </p>
          <ul>
            <li>Learn about human biological diversity across different geographic regions</li>
            <li>Understand how populations have adapted to various environments over thousands of years</li>
            <li>Improve geographic knowledge and spatial awareness</li>
            <li>Appreciate the rich diversity of human populations worldwide</li>
            <li>Challenge common misconceptions about race and ethnicity</li>
          </ul>
        </section>

        <section>
          <h2>Data Sources</h2>
          <p>
            The phenotype data used in PhenoGuessr is sourced from publicly available educational
            resources and anthropological databases. All images represent population-level characteristics
            rather than specific individuals, emphasizing the educational and scientific nature of the game.
          </p>
        </section>

        <section>
          <h2>Game Modes</h2>
          <p>
            <strong>Random Game:</strong> Play 10 rounds with randomly selected phenotypes from our database.
            Each game generates a unique ID that you can share with friends to compare scores on the same
            phenotypes.
          </p>
          <p>
            <strong>Daily Challenge:</strong> A new set of 10 phenotypes is selected each day. Compete with
            players worldwide on the same daily challenge and see who can achieve the highest score!
          </p>
        </section>

        <section>
          <h2>Privacy & Respect</h2>
          <p>
            We are committed to presenting human diversity in a respectful, educational manner. This game
            is intended to celebrate the rich tapestry of human populations and promote geographic literacy.
            We do not collect personal information about players, and all phenotype data is used purely for
            educational purposes.
          </p>
        </section>

        <section>
          <h2>Contact & Feedback</h2>
          <p>
            Have questions, suggestions, or feedback? We'd love to hear from you! PhenoGuessr is continuously
            being improved based on player input and educational research. Your feedback helps make the game
            better for everyone.
          </p>
        </section>

        <div className="cta-section">
          <button className="primary-button" onClick={() => navigate('/')}>
            Start Playing
          </button>
        </div>
      </div>
    </div>
  );
}

export default About;
